import { render, staticRenderFns } from "./BaseCombobox.vue?vue&type=template&id=d2c576a2&scoped=true&"
import script from "./BaseCombobox.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseCombobox.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseCombobox.vue?vue&type=style&index=0&id=d2c576a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c576a2",
  null
  
)

export default component.exports